<div class="file-upload-wrapper">
  @if(rightLabel){
    <div class="d-flex justify-content-between align-items-center">
      <label  class="naps-label">{{ label }} 
          @if(isRequired){
              <sup class="nsdc-text-error" >*</sup>
          }
          @if(tooltipText){
            <i class="sd sd-info-circle ml-1"
             placement="top" [ngbTooltip]="tooltipText" ngbTooltipClass="m-tooltip" ></i>
          }
        </label>
          <label  class="right-label" (click)="rightButtonClicked.emit('')" >{{rightLabel}}</label>
  </div>
  }@else {
    <label  class="naps-label">{{ label }} 
      @if(isRequired){
          <sup class="nsdc-text-error" >*</sup>
      }
      @if(tooltipText){
      <i class="sd sd-info-circle ml-1" placement="top" [ngbTooltip]="tooltipText" ngbTooltipClass="m-tooltip"></i>}
    </label>
  }
   
    <div class="upload-box">
      <input type="file" [accept]="accept" (change)="onFileChosen($event)" #fileInput hidden />
      <span class="file-name"  [title]="selectedFileName || fileName || 'Add file'" >{{ selectedFileName || fileName || 'Add file' }}</span>
      @if(!isDisabled){
        <button type="button" class="browse-btn" (click)="triggerFileInput()">Browse</button>
      }
    </div>
    <div class="d-inline-block upload-note">
      <i class="sd sd-info-circle"></i> <span class=" ml-1" >{{ note }}</span> 
    </div>
    <ng-content></ng-content>
  </div>
  

  
  <!-- <app-file-upload (fileSelected)="onFileSelected($event)"></app-file-upload> -->

  <!-- <form [formGroup]="form">
    <app-file-upload formControlName="contractFile"></app-file-upload>
  </form> -->

  <!-- <app-file-upload #fileUploadComp formControlName="id_proof"></app-file-upload> -->

  <!-- @ViewChild('fileUploadComp') fileUploadComp!: FileUploadComponent;

docProof(event): any {

  if (this.statusProof === 'size issue' || this.statusProof === 'file issue') {
    this.fileuploadProof = null;
    // 🎯 Now call reusable component method
    this.fileUploadComp.clearFile();
  }
} -->

  